"use client"
import { PDFDocument } from "pdf-lib"
import { FiDownload } from "react-icons/fi"

const PDFMerger = ({ files, isLoading, setIsLoading, error, setError }) => {
  const mergePDFs = async () => {
    if (files.length === 0) {
      setError("No PDF files to merge.")
      return
    }

    try {
      setIsLoading(true)
      setError(null)

      // Create a new PDF document
      const mergedPdf = await PDFDocument.create()

      // Process each PDF file
      for (const fileObj of files) {
        const fileBytes = await readFileAsArrayBuffer(fileObj.file)
        const pdf = await PDFDocument.load(fileBytes)
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
        copiedPages.forEach((page) => mergedPdf.addPage(page))
      }

      // Save the merged PDF
      const mergedPdfBytes = await mergedPdf.save()

      // Create a download link
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = `merged_document_${new Date().toISOString().slice(0, 10)}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      setIsLoading(false)
    } catch (err) {
      console.error("Error merging PDFs:", err)
      setError(`Error merging PDFs: ${err.message}`)
      setIsLoading(false)
    }
  }

  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsArrayBuffer(file)
    })
  }

  return (
    <button
      onClick={mergePDFs}
      disabled={isLoading || files.length === 0}
      className={`flex items-center px-4 py-2 text-white rounded-lg ${
        isLoading || files.length === 0 ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
      }`}
    >
      {isLoading ? (
        <span className="flex items-center">
          <svg
            className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Processing...
        </span>
      ) : (
        <>
          <FiDownload className="mr-2" />
          Merge & Download
        </>
      )}
    </button>
  )
}

export default PDFMerger
